import { Link } from "react-router-dom";

const KYouthNav = () => {
  const path = window.location.pathname;

  return (
    <ul className="mainmenu">
      <li>
        <a href={!path.includes("k-youth") ? "/k-youth#" : "#"}>Home</a>
      </li>

      <li>
        <a href="https://pepperlabs.my">About Us</a>
      </li>

      <li>
        <a
          href={
            !path.includes("k-youth")
              ? "/k-youth#what-we-offer"
              : "#what-we-offer"
          }
        >
          What We Offer
        </a>
      </li>

      <li>
        <a href={!path.includes("k-youth") ? "/k-youth#faq" : "#faq"}>FAQ</a>
      </li>

      <li>
        <a
          href={
            !path.includes("k-youth")
              ? "/k-youth#k-youth-programme-2026"
              : "#k-youth-programme-2026"
          }
        >
          K-Youth Programme 2026
        </a>
      </li>

      <li>
        <Link to="/contact-us">Contact Us</Link>
      </li>
    </ul>
  );
};
export default KYouthNav;
